'use strict';

import { threeJsVariables } from '../../settings';

export class FPS {
    constructor () {
        this.beginTime = ( performance || Date ).now();
        this.prevTime = this.beginTime;
        this.frames = 0;
        this.fps = 0;
        this.time = 0;
        this.tasks = [];
        this.finishedTasks = [];
    }

    end() {
        this.frames ++;

        this.time = ( performance || Date ).now();

        if ( this.time >= this.prevTime + 1000 ) {

            this.fps = ( this.frames * 1000 ) / ( this.time - this.prevTime);
            this.runTasks();

            this.prevTime = this.time;
            this.frames = 0;
        }

        return this.time;
    }

    update() {
        this.beginTime = this.end();
    }

    addTask(task) {
        this.tasks.push(task);
    }

    runTasks() {
        if (this.tasks.length) {
            this.tasks.forEach(task => {
                if (!task.finished) {
                    task.progress(this.framesPerSecond);
                } else {
                    this.finishedTasks.push(task);
                }
            });

            if (this.finishedTasks.length) {
                this.tasks = this.tasks.filter(task => !this.finishedTasks.includes(task));
                this.finishedTasks.forEach(task => task.dispose());
                this.finishedTasks = [];
            }
        }
    }

    get framesPerSecond() {
        return Math.round(this.fps);
    }

}

export class OptimizationTask {
    constructor (task = (fps) => {},step = 5,maxCount = 5) {
        this.completed = false;
        this.task = task;
        this.frame = 0;
        this.step = step;
        this.maxCount = maxCount;
        this.currentCount = 0;

        threeJsVariables.fps.addTask(this);
    }

    progress(fps) {
        if (!this.finished) {
            this.frame++;

            if (this.frame === this.step && this.currentCount < this.maxCount) {
                this.task(fps);
                this.frame = 0;
                this.currentCount++;
            }

            if (this.currentCount >= this.maxCount) {
                this.finished = true;
            }
        }
    }

    dispose() {
        this.completed = null;
        this.task = null;
        this.frame = null;
        this.step = null;
        this.maxCount = null;
        this.currentCount = null;
    }

    set finished(value) {
        this.completed = value;
    }

    get finished() {
        return this.completed;
    }

}